import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 6rem);

  .tour-title,
  .cma-title,
  .property-title,
  .document-title,
  .flyer-title {
    display: none;
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: ${({ isFullPage }) => !isFullPage && "4.8rem 2.4rem"};
  background-color: ${({ theme, isFullPage }) =>
    isFullPage
      ? theme.styleGuide.colors.gray[200]
      : theme.styleGuide.colors.white};
  position: relative;

  ${({ theme }) => theme.media.sm`
    padding: ${(isFullPage) => !isFullPage && "2.4rem"};
  `}

  .fullscreen {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  padding: ${({ isFullPage }) => !isFullPage && "4.8rem 2.4rem"};
  background-color: ${({ theme, isFullPage }) =>
    isFullPage
      ? theme.styleGuide.colors.gray[200]
      : theme.styleGuide.colors.white};
  position: relative;

  ${({ theme }) => theme.media.sm`
    padding: ${(isFullPage) => !isFullPage && "2.4rem"};
  `}

  .fullscreen {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
`;

export const Wrapper = styled.div`
  flex-grow: 1;
  max-width: ${({ isFullPage }) => !isFullPage && "68rem"};
  margin: 0 auto;
  overflow: ${({ isFullPage }) => isFullPage && "hidden"};
`;

export const IFrame = styled.iframe`
  flex-grow: 1;
  width: 100%;
  border: 0;
`;
